import { render, staticRenderFns } from "./article-tabbed-content.vue?vue&type=template&id=6e6befaf&scoped=true&"
import script from "./article-tabbed-content.vue?vue&type=script&lang=js&"
export * from "./article-tabbed-content.vue?vue&type=script&lang=js&"
import style0 from "./article-tabbed-content.vue?vue&type=style&index=0&id=6e6befaf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6befaf",
  null
  
)

export default component.exports